<template>
  <div>
    <app-header></app-header>

    <div class="container content" v-if="result">
      <div class="flex-between">
        <h1 class="fio">
          {{result.player.last_name}} {{result.player.first_name}} {{result.player.middle_name}}
        </h1>

        <div class="btn" @click="print">Печать</div>
      </div>

      <!--<div class="groups">
        <b>Группы:</b>
        <ul>
          <li>Первая (экономика),</li>
          <li>Вторая (менеджмент)</li>
        </ul>
      </div>-->

      <b>Программа: «{{this.result.test.name}}»</b>
      <div class="upper" v-if="result.payload.success">пройден</div>
      <div class="upper" v-else>не пройден</div>
      <div class="info">
        Дата: {{result.date_completed | date('HH:mm, DD.MM.YY')}} <br>
        <!--Попытки: 3 <br>-->
        <span v-if="testScore"> Баллы: {{scorePoints(result.payload.score, testScore )}}</span>
        <span v-else> Баллы: 0</span> <br>
        Ошибок: {{result.payload.critical_count}}
      </div>
      <div class="radar">
        <v-radar
          :stats="stats"
          :polycolor="polycolor"
          :radar="radar"
          :scale="scale">
        </v-radar>

        <div class="stats">
          <ul>
            <li v-for="(stat, index) in stats" :key="stat.name"><span class="blue">
              {{stat.shortName}}</span> {{stat.name}} ({{stat.initialValue}}/{{result.test.points[index].value}})</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Radar from 'vue-radar'
  import TestsService from '@/services/TestsService'

  export default {
    name: 'Result',
    components: {
      'v-radar': Radar
    },
    data () {
      return {
        result: '',
        testScore: '',
        orgSlug: '',
        radar: {
          structure: {
            external: { // external stroke of the structure's polygon
              strokeColor: 'rgba(0, 0, 0, 1)', // color (any css format is usable (hexa, rgb, rgba...))
              strokeWidth: '4' // pixel unit
            },
            internals: { // internals stroke of the structure's polygon (one every 10%)
              strokeColor: 'rgba(0, 0, 0, .3)', // color (any css format is usable (hexa, rgb, rgba...))
              strokeWidth: '1' // pixel unit
            },
            average: { // average polygon (placed at 50%)
              strokeColor: 'rgba(0, 0, 0, 1)', // stroke color (any css format is usable (hexa, rgb, rgba...))
              strokeWidth: '0', // pixel unit
              fillColor: 'rgba(0, 0, 0, .2)' // polygon color (any css format is usable (hexa, rgb, rgba...))
            }
          },
          lines: { // lines from center to summits
            strokeColor: 'rgba(0, 0, 0, .3)', // color (any css format is usable (hexa, rgb, rgba...))
            strokeWidth: '1' // pixel unit
          }
        },
        scale: {},
        stats: [],
        polycolor: 'rgba(31, 136, 217, .5)',
        testId: ''
      }
    },
    methods: {
      print () {
        window.print()
      },
      scorePoints (score, test) {
        let result = Math.floor(score * 100 / test)
        return result
      }
    },
    computed: {
      groupId () {
        return this.$store.getters.groupId
      }
    },
    mounted () {
      let playerId = this.$route.params.playerId
      let resultId = this.$route.params.resultId
      this.orgSlug = this.$store.getters.slug

      // TestsService.getTest(this.orgSlug, resultId).then(
      //   (response) => {
      //     this.testScore = response.score
      //   }
      // )

      TestsService.getTestResultsByPlayerId(this.orgSlug, playerId).then(
        (response) => {
          this.testId = response[0].test.id
          TestsService.getTest(this.orgSlug, this.testId).then(
            (response) => {
              this.testScore = response.score
            }
          )
        }
      )

      TestsService.getTestResultByPlayerIdAndTestId(playerId, resultId).then(
        (response) => {
          this.result = response
          this.stats = []
          for (let i in this.result.payload.points) {
            let stat = {
              shortName: String.fromCharCode(65 + parseInt(i)), // A B C
              name: this.result.payload.points[i].name,
              value: this.result.payload.points[i].value * (100 / this.result.test.points[i].value),
              initialValue: parseFloat(this.result.payload.points[i].value).toFixed(2)
            }
            this.stats.push(stat)
          }
        }
      )
    }
  }
</script>

<style scoped lang="scss">

  .upper {
    margin-top: 30px;
    text-transform: uppercase;
    color: $blue;
    padding: 10px 20px;
    border: 1px solid $blue;
    width: max-content;
  }

  .v-radar {
    margin-right: 50px;
  }

  .radar {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .groups {
    margin-bottom: 40px;
    ul {
      list-style: none;
      padding: 0;
    }
  }

  .info {
    margin-top: 40px;
    margin-bottom: 50px;
  }

  .stats {
    ul {
      list-style: none;
      line-height: 3em;
      padding: 0;
    }
    .blue {
      color: $blue;
      padding-right: 10px;
    }
  }

  @media print {
    .header {
      display: none;
    }
    .radar {
      display: block;
    }

    .btn {
      display: none;
    }

    .stats {
      ul {
        list-style: none;
        line-height: 1.5em;
      }
      .blue {
        color: $blue;
        padding-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/players/Result.vue